<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uglDW5TMEBazcF9VZGxHvYD" lang="en-US"><a id="uxX2ddj3CuwJ6ebjLu9Csn8"></a>Note</p>
<p class="Normal" lang="en-US">Some names have been changed and denoted as such by an asterisk (*).</p>
<p class="Normal _idGenParaOverride-1" lang="en-US">Quoted material was taken from printed sources and appears as is. Any mistakes are the original author’s.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Note.vue?eaf750bc